/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Статус, к типу которого относится заявка в текущий момент
 * @export
 * @enum {string}
 */
export enum ApplicationStatus {
  StatusIssued = 'FILTER_STATUS_ISSUED',
  StatusSendIntoRospatent = 'FILTER_STATUS_SEND_INTO_ROSPATENT',
  StatusExpertise = 'FILTER_STATUS_EXPERTISE',
  StatusPayment = 'FILTER_STATUS_PAYMENT',
  All = 'FILTER_ALL',
  StatusOnCompleted = 'FILTER_STATUS_ON_COMPLETED',
}

export function instanceOfApplicationStatus(value: any): boolean {
  for (const key in ApplicationStatus) {
    if (Object.prototype.hasOwnProperty.call(ApplicationStatus, key)) {
      if (ApplicationStatus[key as keyof typeof ApplicationStatus] === value) {
        return true
      }
    }
  }
  return false
}

export function ApplicationStatusFromJSON(json: any): ApplicationStatus {
  return ApplicationStatusFromJSONTyped(json, false)
}

export function ApplicationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationStatus {
  return json as ApplicationStatus
}

export function ApplicationStatusToJSON(value?: ApplicationStatus | null): any {
  return value as any
}
